import React, { useRef, useEffect } from 'react';
import ItemCard from '../ItemCard/ItemCard';
import './ProgramasSlider.css';
import { Link } from 'react-router-dom';
import { slide } from '../../utils/sliderFunctions';

export const ProgramasSlider = ({ area, programas, loading }) => {
  const areaId = area.id;
  const sliderRef = useRef(null);
  const itemsRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (itemsRef.current && !loading) {
      console.log(itemsRef.current);
      slide(
        sliderRef.current,
        itemsRef.current,
        prevRef.current,
        nextRef.current
      );
    }
  }, [itemsRef, loading]);

  const fillPreload = () => {
    return [1, 2, 3, 4].map((pre) => {
      return <ItemCard key={pre} loading={loading} style={'slide'} />;
    });
  };

  const fillItems = () => {
    let key = 1;
    return (
      <div id={`items-${area.id}`} className="items" ref={itemsRef}>
        {programas?.map((programa) => {
          if (programa.area === areaId) {
            return (
              <ItemCard
                key={key++}
                programa={programa}
                area={area}
                style={'slide'}
                loading={loading}
              />
            );
          }
        })}
      </div>
    );
  };

  const fillButtons = () => {
    return (
      <>
        <span id="prev" className="control prev" ref={prevRef}>
          <i className="fas fa-chevron-left Areas__arrow"></i>
        </span>
        <span id="next" className="control next" ref={nextRef}>
          <i className="fas fa-chevron-right Areas__arrow"></i>
        </span>
      </>
    );
  };

  const fillFooter = () => {
    if (!loading)
      return (
        <Link to={`area/${area.slug}`} className="Areas__verTodas">
          Ver todos
        </Link>
      );
  };

  const fillContent = () => {
    return (
      <div id={`slider-${area.id}`} className="slider" ref={sliderRef}>
        <h2>{area.nombre}</h2>
        <div className="wrapper">
          <div className="wrapper">{fillItems()}</div>
          {fillButtons()}
        </div>
        {fillFooter()}
      </div>
    );
  };

  return loading ? fillPreload() : fillContent();
};
